import api from '../../data/api'

const route = '/permissions-v2'

export const savePermissionsDocument = (permissionsDocument) => {
  return (dispatch) => {
    dispatch({
      type: 'permission-v2/save-started'
    })

    const method = 'post'
    return api[method](route, permissionsDocument).then(async (response) => {
      await dispatch({
        type: 'permission-v2/update-success',
        response
      })

      return response
    })
  }
}
export const fetchPermissionsDocumentForEditing = ({
  tenant,
  role,
  personnelId
}) => {
  return (dispatch) => {
    dispatch({
      type: 'permission-v2/fetch-started'
    })

    const params = new URLSearchParams()
    if (tenant) {
      params.append('tenant', tenant)
    }
    if (role) {
      params.append('role', role)
    }
    if (personnelId) {
      params.append('personnel', personnelId)
    }
    const method = 'get'
    return api[method](route + '/edit' + '?' + params.toString()).then(
      async (response) => {
        await dispatch({
          type: 'permission-v2/fetch-success',
          response
        })
        return response
      }
    )
  }
}
export const fetchSystemPermissions = () => {
  const method = 'get'
  return (dispatch) => {
    return api[method](route + '/system-permissions').then(async (response) => {
      await dispatch({
        type: 'permission-v2/system-permissions-fetch-success',
        response
      })
      return response
    })
  }
}

let promiseRepository = {}

export const fetchPermissionsDocument = ({ tenant, role, personnelId }) => {
  return (dispatch) => {
    dispatch({
      type: 'permission-v2/fetch-started'
    })

    const params = new URLSearchParams()
    if (tenant) {
      params.append('tenant', tenant)
    }
    if (role) {
      params.append('role', role)
    }
    if (personnelId) {
      params.append('personnel', personnelId)
    }
    const key = params.toString()
    if (promiseRepository[key]) {
      return promiseRepository[key]
    }
    const method = 'get'
    const promise = api[method](route + '?' + key)
      .then(async (response) => {
        await dispatch({
          type: 'permission-v2/fetch-success',
          response
        })
        delete promiseRepository[key]
        return response
      })
      .catch((error) => {
        delete promiseRepository[key]
        throw error
      })
    promiseRepository[key] = promise
    return promise
  }
}
